<!-- Global toast container — render once at App root. -->
<script>
	import { toasts, dismiss } from './toast.js';
	import Icon from './Icon.svelte';

	const ICON = { success: 'check-circle', error: 'alert-circle', warning: 'alert-circle', info: 'sparkles' };
</script>

<div class="toaster" aria-live="polite">
	{#each $toasts as t (t.id)}
		<div class="toast {t.kind}" role="status">
			<div class="t-icon"><Icon name={ICON[t.kind] || 'sparkles'} size={16} /></div>
			<div class="t-body">
				{#if t.title}<div class="t-title">{t.title}</div>{/if}
				<div class="t-msg">{t.message}</div>
			</div>
			{#if t.action}
				<button class="t-action" onclick={() => { t.action.run(); dismiss(t.id); }}>
					{t.action.label}
				</button>
			{/if}
			<button class="t-close" onclick={() => dismiss(t.id)} aria-label="Cerrar">
				<Icon name="x" size={13} />
			</button>
		</div>
	{/each}
</div>

<style>
	.toaster {
		position: fixed;
		bottom: 16px;
		right: 16px;
		display: flex;
		flex-direction: column-reverse;
		gap: 8px;
		z-index: 9999;
		max-width: calc(100vw - 32px);
		pointer-events: none;
	}
	.toast {
		pointer-events: auto;
		display: flex; align-items: flex-start; gap: 10px;
		min-width: 280px;
		max-width: 420px;
		padding: 10px 12px;
		background: var(--surface-0);
		border: 1px solid var(--border-1);
		border-left: 3px solid var(--text-2);
		border-radius: 8px;
		box-shadow: var(--shadow-lg);
		font-size: 13px;
		color: var(--text-1);
		animation: toast-in 200ms cubic-bezier(0.4, 0, 0.2, 1);
	}
	.toast.success { border-left-color: var(--success); }
	.toast.error   { border-left-color: var(--danger); }
	.toast.warning { border-left-color: var(--warning); }
	.toast.info    { border-left-color: var(--accent); }
	.t-icon {
		width: 22px; height: 22px;
		flex-shrink: 0;
		display: flex; align-items: center; justify-content: center;
		border-radius: 50%;
		background: var(--surface-2);
		color: var(--text-2);
		margin-top: 1px;
	}
	.toast.success .t-icon { background: var(--success-soft); color: var(--success); }
	.toast.error   .t-icon { background: var(--danger-soft);  color: var(--danger); }
	.toast.warning .t-icon { background: var(--warning-soft); color: #b45309; }
	.toast.info    .t-icon { background: var(--accent-soft);  color: var(--accent); }
	.t-body { flex: 1; min-width: 0; }
	.t-title { font-weight: 600; margin-bottom: 2px; }
	.t-msg   { color: var(--text-2); line-height: 1.4; }
	.t-action {
		font-weight: 600;
		color: var(--accent);
		font-size: 12.5px;
		padding: 4px 8px;
		border-radius: 6px;
	}
	.t-action:hover { background: var(--accent-soft); }
	.t-close {
		width: 22px; height: 22px;
		display: flex; align-items: center; justify-content: center;
		border-radius: 4px;
		color: var(--text-3);
		flex-shrink: 0;
	}
	.t-close:hover { color: var(--text-1); background: var(--surface-2); }

	@keyframes toast-in {
		from { transform: translateY(8px); opacity: 0; }
		to   { transform: translateY(0); opacity: 1; }
	}
</style>
